var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWwStep11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0863 77.2545C22.4725 77.2545 19.9969 76.6772 17.7727 75.6466L7.08398 77.9168L9.31878 67.2068C8.28107 64.9756 7.70023 62.4893 7.70023 59.8685",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0863 77.2545C22.4725 77.2545 19.9969 76.6772 17.7727 75.6466L7.08398 77.9168L9.31878 67.2068C8.28107 64.9756 7.70023 62.4893 7.70023 59.8685",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2227 42.5993C21.9548 39.6916 21.25 36.5218 21.25 33.1962C21.25 18.9693 33.9929 7.5545 49.5833 7.5545C65.1738 7.5545 77.9167 18.9693 77.9167 33.1962C77.9167 41.6041 73.4471 49.0062 66.5869 53.6741C66.5904 56.3516 66.5833 59.9605 66.5833 63.7501L55.466 58.2747C53.5642 58.6395 51.5985 58.8378 49.5833 58.8378C47.0794 58.8378 44.6498 58.5403 42.3335 57.9843",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2227 42.5993C21.9548 39.6916 21.25 36.5218 21.25 33.1962C21.25 18.9693 33.9929 7.5545 49.5833 7.5545C65.1738 7.5545 77.9167 18.9693 77.9167 33.1962C77.9167 41.6041 73.4471 49.0062 66.5869 53.6741C66.5904 56.3516 66.5833 59.9605 66.5833 63.7501L55.466 58.2747C53.5642 58.6395 51.5985 58.8378 49.5833 58.8378C47.0794 58.8378 44.6498 58.5403 42.3335 57.9843",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0676 77.2367C34.6584 77.2367 42.4359 69.4592 42.4359 59.8683C42.4359 50.2775 34.6619 42.5 25.0676 42.5C15.4732 42.5 7.69922 50.2775 7.69922 59.8683",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0676 77.2367C34.6584 77.2367 42.4359 69.4592 42.4359 59.8683C42.4359 50.2775 34.6619 42.5 25.0676 42.5C15.4732 42.5 7.69922 50.2775 7.69922 59.8683",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4144 58.585C19.1952 59.365 19.1952 60.633 18.4144 61.413C17.6332 62.193 16.3668 62.193 15.5856 61.413C14.8048 60.633 14.8048 59.365 15.5856 58.585C16.3668 57.805 17.6332 57.805 18.4144 58.585Z",
    fill: "#63C7C9",
    stroke: "#353B60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3832 58.585C27.1639 59.365 27.1639 60.633 26.3832 61.413C25.602 62.193 24.3355 62.193 23.5543 61.413C22.7736 60.633 22.7736 59.365 23.5543 58.585C24.3355 57.805 25.602 57.805 26.3832 58.585Z",
    fill: "#63C7C9",
    stroke: "#353B60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3519 58.585C35.1327 59.365 35.1327 60.633 34.3519 61.413C33.5707 62.193 32.3043 62.193 31.5231 61.413C30.7423 60.633 30.7423 59.365 31.5231 58.585C32.3043 57.805 33.5707 57.805 34.3519 58.585Z",
    fill: "#63C7C9",
    stroke: "#353B60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.584 26.6865C50.3986 25.794 51.8046 24.7917 53.9473 24.7917C57.6944 24.7917 60.209 28.089 60.209 31.1596C60.209 37.5806 51.6842 42.5 49.584 42.5C47.4838 42.5 38.959 37.5806 38.959 31.1596C38.959 28.089 41.4736 24.7917 45.2206 24.7917C47.3634 24.7917 48.7694 25.794 49.584 26.6865Z",
    fill: "#5458F7",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwStep11);
export default __webpack_public_path__ + "static/media/ww-step11.ed051b22.svg";
export { ForwardRef as ReactComponent };